// extracted by mini-css-extract-plugin
module.exports = {"card":"card__EUNcZ","text":"text__28zRA"};